/*
* Custom validation methods to be used by the jQuery.validate plugin
*
*/


$(function() {
	// Add valid risk number:
	$.validator.addMethod('riskId', function(value, element, params) {
		return /^(R\d+-\d{2})$/i.test(value) || value.length == 0;
	});


	$.validator.addMethod("delimitedCount", function (value, element, params) {
	    var v = value.match(/([0-9]*(?:cm|px|in)[;, -]?)/gi);
	    return (v != undefined && v != null && v.length == params);
	});
	$.validator.addMethod("columnWidthsFormat", function (value, element, params) {
	    return /^([0-9\.]*(?:cm|px|in)[;, -]?)*$/i.test(value) || value.length == 0;
	});
	// Add Hazard Number
	$.validator.addMethod('hazardId', function(value, element, params) {
		return /^(H\d+-\d{2})$/i.test(value) || value.length == 0;
	});

	// Add Risk Review Number
	$.validator.addMethod('riskReviewId', function(value, element, params) {
		return /^(\d+\/([A-Z]*)RR\/\d+)$/i.test(value) || value.length == 0;
	});

	// Add Occurrence Number
	$.validator.addMethod('occurrenceId', function(value, element, params) {
		return /^(O\d+-\d{2})$/i.test(value) || value.length == 0;
	});

	// Add Finding Number
	$.validator.addMethod('findingId', function(value, element, params) {
		return /^(\Fd+-\d{2})$/i.test(value) || value.length == 0;
	});
	// Used for Risk Search, can be RiskId, OccurrenceId, HazardId, FindingId, or RiskReviewID
	$.validator.addMethod('riskReviewSearchNumber', function(value, element, params) {
		return /^(\d+\/[A-Z]{0,1}RR\/\d+)$/i.test(value) ||
		/^(H\d+-\d{2})$/i.test(value) ||
		 /^(O\d+-\d{2})$/i.test(value) ||
		/^(R\d+-\d{2})$/i.test(value) ||
		/^(\Fd+-\d{2})$/i.test(value) ||
		value.length == 0;
	});

	// Used for Risk Search, can be RiskId or RiskReviewID
	$.validator.addMethod('riskSearchNumber', function(value, element, params) {
		return /^(\d+\/([A-Z]{0,1})RR\/\d+)$/i.test(value) ||
		/^(R\d+-\d{2})$/i.test(value) ||
		/^(H\d+-\d{2})$/i.test(value) ||
		value.length == 0;
	});
	// Used for Occurrence Search, can be RiskId or RiskReviewID
	$.validator.addMethod('occurrenceSearchNumber', function(value, element, params) {
		return /^(\d+\/([A-Z]{0,1})RR\/\d+)$/i.test(value) ||
		/^(R\d+-\d{2})$/i.test(value) ||
		value.length == 0;
	});
});